import React from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

const SortableTableHeader = ({
  label,
  fieldKey = null,
  sortBy = null,
  sortOrder = 'desc',
  onSort = () => {},
  align = 'left',
  thClassName = '',
}) => {
  const isSortable = Boolean(fieldKey)
  const isActive = isSortable && sortBy === fieldKey
  const alignClass = align === 'right' ? 'text-right' : 'text-left'

  const handleClick = () => {
    if (isSortable) {
      onSort(fieldKey)
    }
  }

  return (
    <th
      onClick={handleClick}
      className={`py-4 px-6 text-xs font-semibold text-gray-600 uppercase tracking-wider ${alignClass} ${thClassName} ${
        isSortable
          ? 'cursor-pointer select-none hover:text-gray-900 transition-colors'
          : ''
      }`}
    >
      <span
        className={`inline-flex items-center gap-1 ${
          alignClass === 'text-right' ? 'justify-end' : ''
        }`}
      >
        {label}
        {isActive && (
          <span className="text-blue-600">
            {sortOrder === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          </span>
        )}
      </span>
    </th>
  )
}

export default SortableTableHeader